import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import {
  Box,
  Grid,
  Card,
  Chip,
  Stack,
  Button,
  Pagination,
  Typography,
  CardContent,
} from "@mui/material";
import moment from "moment";
//Import from project
import "./studentenrollment.scss";
import EmptyData from "../Include/EmptyData";
import LoadingPage from "../Include/LoadingPage";
import EnrollmentAction from "./EnrollmentAction";
import GenderImage from "../../Assets/equality.png";
import AllowClassStudent from "./AllowClassStudent";
import EmptyImage from "../../Assets/empty-image.png";
import CakeImage from "../../Assets/birthday-cake.png";
import { SelectAcademicYear } from "../Include/DynamicSelect";
import { GET_ENROLLMENT_BY_STUDENT } from "../../Schema/Enrollment";
import { GET_ACTIVE_ACADEMIC_YEAR } from "../../Schema/SelectSchema";

export default function StudentEnrollment({ detailsData }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [loading, setLoading] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [paginationData, setPaginationData] = useState();
  const [enrollType, setEnrollType] = useState("Current");
  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });

  const { data } = useQuery(GET_ACTIVE_ACADEMIC_YEAR, {
    onCompleted: ({ getActiveAcademicYear }) => {
      setAcademicYearVal({
        id: getActiveAcademicYear?._id,
        title: getActiveAcademicYear?.academicYearName,
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { refetch } = useQuery(GET_ENROLLMENT_BY_STUDENT, {
    variables: {
      page: page,
      limit: limit,
      academicYearId: academicYearVal?.id,
      studentId: detailsData?._id,
      enrollType: enrollType,
    },
    onCompleted: ({ getEnrollmentsByStudentPagination }) => {
      setCardData(getEnrollmentsByStudentPagination?.data);
      setPaginationData(getEnrollmentsByStudentPagination?.paginator);
      setLoading(false);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    refetch();
  }, [page, academicYearVal?.id, detailsData?._id]);

  const ColorGenerateor = () => {
    return Math.random().toString(16).substr(-6);
  };

  return (
    <div className="student-enrollment">
      <Box className="main-containner">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={5} lg={4} xl={3}>
            <Box className="profile-container">
              <Stack
                className="profile"
                direction="row"
                justifycontent="center"
                sx={{ marginBottom: "20px" }}
              >
                <img
                  className="avater-image"
                  style={{ borderRadius: "10px" }}
                  src={
                    detailsData?.profileImg === "" ||
                    detailsData?.profileImg === undefined ||
                    detailsData?.profileImg === null
                      ? EmptyImage
                      : detailsData?.profileImg?.slice(0, 5) === "https"
                      ? detailsData?.profileImg
                      : `${process.env.React_App_VIEW_URL}${detailsData?.profileImg}`
                  }
                />
              </Stack>
              <Typography className="name-container-khmer">
                {detailsData?.lastName + " " + detailsData?.firstName}
              </Typography>
              <Typography className="name-container">
                {detailsData?.englishName}
              </Typography>
              <Stack
                direction="row"
                justifyContent="center"
                sx={{ marginTop: "20px" }}
              >
                <Stack direction="row" spacing={4} sx={{ width: "70%" }}>
                  <Stack
                    direction="column"
                    spacing={1}
                    className="birthday-card"
                  >
                    <Stack direction="row" justifyContent="center">
                      <img
                        src={GenderImage}
                        alt="Gender"
                        className="cake-img"
                      />
                    </Stack>
                    <Typography className="cake-title">
                      {detailsData?.gender}
                    </Typography>
                  </Stack>
                  <Stack
                    direction="column"
                    spacing={1}
                    className="birthday-card"
                  >
                    <Stack direction="row" justifyContent="center">
                      <img src={CakeImage} alt="Gender" className="cake-img" />
                    </Stack>

                    <Typography className="cake-title">
                      {moment(detailsData?.dob).format("DD-MMM-YYYY")}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={7} lg={8} xl={9}>
            <Box className="details-container">
              <Stack direction="row" justifyContent="space-between">
                <Box sx={{ width: "300px" }}>
                  <SelectAcademicYear
                    selectedVal={academicYearVal}
                    setSelectedVal={setAcademicYearVal}
                  />
                </Box>
              </Stack>

              <Stack
                direction="row"
                spacing={0}
                sx={{ borderBottom: "1px solid rgb(202, 201, 201)" }}
              >
                <Button
                  onClick={() => setEnrollType("Current")}
                  className={
                    enrollType === "Current"
                      ? "btn-current-enroll-active"
                      : "btn-current-enroll"
                  }
                >
                  Current Class
                </Button>

                <Button
                  onClick={() => setEnrollType("History")}
                  className={
                    enrollType === "History"
                      ? "btn-current-enroll-active"
                      : "btn-current-enroll"
                  }
                >
                  History Class
                </Button>
              </Stack>

              {loading ? (
                <LoadingPage />
              ) : (
                <Box sx={{ marginTop: "10px" }}>
                  {cardData?.length === 0 ? (
                    <EmptyData />
                  ) : (
                    <Grid container direction="row" spacing={3}>
                      {cardData?.map((item, index) => {
                        // console.log("item::", item);
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={12}
                            lg={6}
                            xl={4}
                            key={index}
                          >
                            <Card
                              variant="outlined"
                              size="md"
                              sx={{
                                border: `1px solid #${ColorGenerateor()}`,
                                borderRadius: "12px",
                              }}
                            >
                              <CardContent>
                                <Stack direction="column">
                                  <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    <Stack
                                      spacing={2}
                                      width="100%"
                                      direction="row"
                                      alignItems="center"
                                    >
                                      <Stack
                                        spacing={1}
                                        width="100%"
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                      >
                                        <Stack
                                          spacing={1}
                                          direction="row"
                                          alignItems="center"
                                          justifyContent="center"
                                        >
                                          {item?.isAllowInClass === false ? (
                                            <Box className="not-active-icon" />
                                          ) : (
                                            <Box className="active-icon" />
                                          )}
                                          <Typography
                                            className={
                                              item?.isAllowInClass
                                                ? "text-active"
                                                : "text-inactive"
                                            }
                                          >
                                            Allow Class
                                          </Typography>
                                        </Stack>

                                        <Stack direction="column" spacing={1}>
                                          <AllowClassStudent
                                            studentId={detailsData?._id}
                                            editData={item}
                                          />
                                          {item?.customerType && (
                                            <Typography
                                              fontSize="11px"
                                              style={{
                                                fontWeight: "bold",
                                                borderRadius: "8px",
                                                textAlign: "center",
                                                padding: "0px 8px",
                                                backgroundColor:
                                                  item?.customerType ===
                                                  "Simple"
                                                    ? "#0f81c2"
                                                    : item?.customerType ===
                                                      "Special"
                                                    ? "green"
                                                    : item?.customerType ===
                                                      "Shareholder"
                                                    ? "red"
                                                    : "#F4D03F",
                                              }}
                                            >
                                              {item?.customerType}
                                            </Typography>
                                          )}
                                        </Stack>
                                      </Stack>
                                    </Stack>

                                    <Box flexGrow={1} />

                                    <EnrollmentAction
                                      editData={item}
                                      setRefetch={refetch}
                                    />
                                  </Stack>

                                  <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                  >
                                    <Stack
                                      direction="column"
                                      justifyContent="center"
                                    >
                                      <Typography
                                        sx={{
                                          fontSize: 18,
                                          fontWeight: "bold",
                                          color: "#5713C6",
                                        }}
                                        color="text.secondary"
                                        gutterBottom
                                      >
                                        {item?.academicYearName}
                                      </Typography>
                                    </Stack>
                                  </Stack>
                                  <Stack direction="row">
                                    <Typography
                                      variant="h6"
                                      component="div"
                                      sx={{
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        color: "#0f81c2",
                                      }}
                                    >
                                      {item?.className}
                                    </Typography>
                                  </Stack>
                                </Stack>
                                <Stack
                                  direction="column"
                                  spacing={1}
                                  sx={{ marginTop: "10px" }}
                                >
                                  <Stack direction="row">
                                    <Typography className="details-name">
                                      Programme
                                    </Typography>
                                    <Typography className="details-dot">
                                      :
                                    </Typography>
                                    <Typography className="details-item">
                                      <Chip
                                        label={item?.programmeName}
                                        sx={{
                                          bgcolor: "#E2F0F7",
                                          borderRadius: "12px",
                                          height: "24px",
                                          color: "#005BFA",
                                          fontWeight: "bold",
                                        }}
                                      />
                                    </Typography>
                                  </Stack>
                                  <Stack direction="row">
                                    <Typography className="details-name">
                                      Shift
                                    </Typography>
                                    <Typography className="details-dot">
                                      :
                                    </Typography>
                                    <Typography className="details-item">
                                      {item?.shiftName}
                                    </Typography>
                                  </Stack>
                                  <Stack direction="row">
                                    <Typography className="details-name">
                                      Start date
                                    </Typography>
                                    <Typography className="details-dot">
                                      :
                                    </Typography>
                                    <Typography className="details-item">
                                      {moment(item?.startSchoolDate)?.format(
                                        "DD-MM-YYYY"
                                      )}
                                    </Typography>
                                  </Stack>
                                  <Stack direction="row">
                                    <Typography className="details-name">
                                      Room
                                    </Typography>
                                    <Typography className="details-dot">
                                      :
                                    </Typography>
                                    <Typography className="details-item">
                                      {item?.classRoomName}
                                    </Typography>
                                  </Stack>

                                  <Stack direction="row">
                                    <Typography className="details-name">
                                      Type
                                    </Typography>
                                    <Typography className="details-dot">
                                      :
                                    </Typography>
                                    <Stack
                                      direction="column"
                                      spacing={1}
                                      className="details-item"
                                    >
                                      {item?.isOldStudent && (
                                        <Typography className="student-type-status">
                                          Old Student
                                        </Typography>
                                      )}
                                      {item?.isReEnroll && (
                                        <Typography className="student-type-status">
                                          Re-Enroll
                                        </Typography>
                                      )}
                                      {item?.isNewStudent ||
                                      item?.isTransferIn ||
                                      item?.isSchoolAge ? (
                                        <Typography className="student-type-status">
                                          New Student
                                        </Typography>
                                      ) : (
                                        ""
                                      )}
                                      {item?.isChangeProgramme && (
                                        <Typography className="student-type-status">
                                          Change programme
                                        </Typography>
                                      )}
                                      {item?.isAddProgramme && (
                                        <Typography className="student-type-status">
                                          Add programme
                                        </Typography>
                                      )}
                                    </Stack>
                                  </Stack>
                                </Stack>
                              </CardContent>
                            </Card>
                          </Grid>
                        );
                      })}
                    </Grid>
                  )}
                </Box>
              )}

              <Stack
                direction="row"
                justifyContent="right"
                spacing={2}
                sx={{ marginTop: "20px" }}
              >
                <Stack direction="column" justifyContent="center">
                  <Pagination
                    hideNextButton={false}
                    hidePrevButton={false}
                    page={page}
                    count={paginationData?.totalPages}
                    color="primary"
                    variant="outlined"
                    onChange={(event, pageNum) => setPage(parseInt(pageNum))}
                  />
                </Stack>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
